import React from 'react';
import { useTranslation } from 'react-i18next';
import avgPaywallImg from '@/assets/images/journals/avg-paywall.webp';
import chartPaywallImg from '@/assets/images/journals/chart-paywall.webp';
import piePaywallImg from '@/assets/images/journals/pie-paywall.webp';
import { JournalPaywallCard } from '@/pages/Overview/JournalPaywallCard';
import type { Journal } from '@/types/journal';
import { getTeacherNames } from '@/utils/journal';

interface Props {
  journal: Journal;
}

export const JournalPaywall: React.FC<Props> = ({ journal }) => {
  const { t } = useTranslation();
  const teacherNames = getTeacherNames(journal);

  return (
    <div className="flex flex-col gap-9 pb-3">
      <div className="flex min-w-0 flex-col gap-2">
        <h1 className="text-title-24 truncate text-foreground">
          {journal.name}
        </h1>
        {!!teacherNames && (
          <p className="text-body-14 truncate text-subtle-foreground">
            {teacherNames}
          </p>
        )}
      </div>

      <section className="flex flex-col gap-4">
        <h2 className="text-callout-16 text-foreground">
          {t('overview.journals.grades')}
        </h2>
        <div className="flex flex-col gap-3">
          <JournalPaywallCard
            description={t('overview.journals.paywall.gradesDescription')}
            image={chartPaywallImg}
          />
          <JournalPaywallCard
            description={t('overview.journals.paywall.averageDescription')}
            image={avgPaywallImg}
          />
        </div>
      </section>

      <section className="flex flex-col gap-3">
        <h2 className="text-callout-16 text-foreground">
          {t('overview.tabs.attendance')}
        </h2>
        <JournalPaywallCard
          description={t('overview.journals.paywall.attendanceDescription')}
          image={piePaywallImg}
        />
      </section>
    </div>
  );
};
